"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Container = _interopRequireDefault(require("../../Utils/Container"));

var _Image = _interopRequireDefault(require("../../Utils/Image"));

var _ImageWrapper = _interopRequireDefault(require("../../Utils/ImageWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var List = _styledComponents["default"].ul.withConfig({
  displayName: "Bubbles__List",
  componentId: "sc-4km6sv-0"
})(["display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-around;list-style:none;margin:2rem 0;padding:0;"]);

var ListItem = _styledComponents["default"].li.withConfig({
  displayName: "Bubbles__ListItem",
  componentId: "sc-4km6sv-1"
})(["flex:0 0 calc(33.3% - 1em);margin:1rem 0;min-width:325px;"]);

var ListItemGrid = _styledComponents["default"].div.withConfig({
  displayName: "Bubbles__ListItemGrid",
  componentId: "sc-4km6sv-2"
})(["align-items:center;display:flex;flex-direction:row;"]);

var ListItemText = _styledComponents["default"].div.withConfig({
  displayName: "Bubbles__ListItemText",
  componentId: "sc-4km6sv-3"
})(["flex:1;padding:1rem;h4{font-size:1.13rem;}p{font-size:1rem;}p,h4{margin:0;}"]);

var ListItemImage = _styledComponents["default"].div.withConfig({
  displayName: "Bubbles__ListItemImage",
  componentId: "sc-4km6sv-4"
})(["border-radius:500px;overflow:hidden;"]);

var Title = _styledComponents["default"].h3.withConfig({
  displayName: "Bubbles__Title",
  componentId: "sc-4km6sv-5"
})(["font-size:calc( 29.479px + (29.479 - 23.086) * ((100vw - 300px) / (1600 - 300)) );margin:0;text-align:center;"]);

var Bubbles = function Bubbles(_ref) {
  var images = _ref.images,
      title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], null, title && /*#__PURE__*/_react["default"].createElement(Title, null, title), /*#__PURE__*/_react["default"].createElement(List, null, images.map(function (img) {
    return /*#__PURE__*/_react["default"].createElement(ListItem, null, /*#__PURE__*/_react["default"].createElement(ListItemGrid, null, /*#__PURE__*/_react["default"].createElement(ListItemImage, null, /*#__PURE__*/_react["default"].createElement(_ImageWrapper["default"], {
      height: "8rem",
      width: "8rem",
      fit: "cover"
    }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
      alt: img.title,
      srcList: img.src
    }))), /*#__PURE__*/_react["default"].createElement(ListItemText, null, /*#__PURE__*/_react["default"].createElement("h4", null, img.title), /*#__PURE__*/_react["default"].createElement("p", null, img.description))));
  })));
};

Bubbles.propTypes = {
  images: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string,
    description: _propTypes["default"].string,
    src: _propTypes["default"].string
  })),
  title: _propTypes["default"].string
};
Bubbles.defaultProps = {
  title: '',
  images: []
};
var _default = Bubbles;
exports["default"] = _default;